<template>
    <el-dialog class="common-dialog notice" :title="dialogData.title"
               :visible.sync="params.visible">
        <div class="warm-hint">
            <p>{{dialogData.content}}</p>
            <p>{{dialogData.hint}}</p>
        </div>
        <el-button class="warm-hint-btn" type="primary" size="full" @click="start()">{{dialogData.btn}}</el-button>
        <div class="warm-hint-radio">
            <!--<el-checkbox v-model="warmHintDialog.checked">下次不再提醒</el-checkbox>-->
            下次不再提醒<el-switch v-model="params.checked" on-text="开" off-text="关" :width="46" style="margin-left:15px"></el-switch>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        props: ['params'],
        data() {
            return {
                dialogData: {
                    title: '亲爱的旋涡用户，你好！',
                    content: '网站营销力诊断功能，主要是对您的网站营销能力进行客观的分析和打分，从而帮助你的网站提升营销能力，但由于各位的网站出自不同的建站公司，所以在网站的写法和习惯上可能会有很多不标准的地方，可能会造成小部分诊断分析不准确，因此诊断结果仅供参考，请根据诊断结果的建议，再结合你的实际情况进行网站的完善和提升，谢谢！',
                    hint: '在此，旋涡营销团队全员祝你网站越来越赚钱！',
                    btn: '好的，我知道了'
                }
            }
        },
        methods: {
            start() {
                this.$emit('start');
            }
        }
    }
</script>

<style lang="scss">
    /*温馨提示*/
    .warm-hint {
        padding: 0 20px;
        border: 1px solid #e6e6e6;
        text-align: left;
        p {
            font-size: 18px;
            color: #646464;
            text-indent: 2em;
        }
    }
    .warm-hint-btn {
        padding: 16px;
        font-size: 24px;
    }
    .warm-hint-radio {
        margin-top: 32px;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// app/view/index/PromptDialog.vue